export default __webpack_public_path__ + "static/media/logo.d82df36e.png";